export function canUseClipboard() {
  return Boolean(
    typeof navigator !== "undefined" &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function",
  );
}

export async function copyPublicUrl(publicUrl) {
  if (!publicUrl) {
    throw new Error("Немає посилання для копіювання.");
  }
  if (!canUseClipboard()) {
    throw new Error("Clipboard API недоступний у цьому браузері.");
  }
  await navigator.clipboard.writeText(publicUrl);
}

export function canUseWebShare() {
  return Boolean(
    typeof navigator !== "undefined" && typeof navigator.share === "function",
  );
}

export function nativeSharePayload(publicUrl, title) {
  return {
    title: title || "Рієстро",
    text: "Презентація об'єкта",
    url: publicUrl,
  };
}

export function isShareCancellation(error) {
  if (!error) return false;
  if (error.name === "AbortError") return true;
  const message = String(error.message || "").toLowerCase();
  return message.includes("abort") || message.includes("cancel");
}

export async function sharePublicUrl(publicUrl, title) {
  if (!publicUrl) {
    throw new Error("Немає посилання для надсилання.");
  }
  if (!canUseWebShare()) {
    await copyPublicUrl(publicUrl);
    return "copied";
  }
  await navigator.share(nativeSharePayload(publicUrl, title));
  return "shared";
}
